import { render } from "./commentShow.vue?vue&type=template&id=fad979e6&scoped=true"
import script from "./commentShow.vue?vue&type=script&lang=js"
export * from "./commentShow.vue?vue&type=script&lang=js"

import "./commentShow.vue?vue&type=style&index=0&id=fad979e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad979e6"]])

export default __exports__